module.exports = __webpack_public_path__ + "img/big_1_82.bf77fe4a.png";